import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import { useState } from "react";
import { useRouter } from "next/router";
import CustomIconButton from "@/src/lib/ui/iconButton";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import TextField from "@/src/components/custom-fields/TextField";

const FindTestByFacility = ({ facilitiesData }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const router = useRouter();

    const isMobile = useBreakpoint("sm");

    const onSerachTestHandler = () => {
        if (!searchTerm.trim()) return;
        router.push({
            pathname: "/find-a-test",
            query: {
                search: searchTerm,
                category: facilitiesData?.categoryId,
            },
        });
    };

    return (
        <div className="bg-white rounded-md max-w-2xl mx-auto md:my-8 my-5 shadow-md flex items-stretch overflow-hidden">
            <TextField
                value={searchTerm}
                placeholder={`Search for ${facilitiesData?.categoryName} Test and Prices`}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                size={isMobile ? "small" : "medium"}
                InputProps={{ className: "ctf-no-border" }}
            />

            <CustomIconButton
                onClick={onSerachTestHandler}
                color="primary"
                className="rounded-none hover:bg-primary/90 rounded-r-md px-4 cursor-pointer"
            >
                <Iconify
                    icon={IconCode.search}
                    width="28px"
                    className="text-white"
                />
            </CustomIconButton>
        </div>
    );
};

export default FindTestByFacility;
